import React from "react";
import LoadingComponent from "../common/loadingComponent/LoadingComponent";
import {useSelector} from "react-redux";

export default function GlobalLoadingComponent() {
    const commonStateLoading = useSelector(state => state.commonState.loading)
    return <LoadingComponent open={commonStateLoading} description/>
}
